import { createSelector } from 'reselect';
import { getProjectLazy } from 'src/modules/common/selectors/getProjectLazy';

export const getHvacCountryCode = createSelector([
  getProjectLazy,
], (project) => project.data.building.address.country);
